import React, { useState } from "react";

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "Can I participate in the Yagam?",
      answer:
        "Sure - you can visit Yaga Mandapam and watch the rituals. However, you cannot perform the rituals.",
    },
    {
      question: "What is the total fund required?",
      answer:
        "Total projected expense of this Yagam is Rs. One Crore (approx. USD 117,000).",
    },
    {
      question: "Why factors contribute to such high cost?",
      answer:
        "This is very expensive because 60+ veda scholars from all 4 vedas are required. In addition, 200+ cows need to be donated (gau danam), which alone costs approx. 75 lakhs (USD 90,000).",
    },
    {
      question: "What is the current funding gap?",
      answer:
        "We could raise only 30 lakhs so far - need 70 more lacs as of Jan 7, 2025.",
    },
    {
      question: "Will I get Yagna Prasadam?",
      answer:
        "Yes - we mail Yagna Bhasmam. Yagna Prasadam can be collected in person as this cannot be mailed. Place and time details will be shared separately.",
    },
    {
      question: "Will my name be included in the “Sankalpam”?",
      answer: "Yes - all donors’ names will be included in the Sankalpam.",
    },
    {
      question: "I am outside of India - How can I contribute?",
      answer:
        "For US Residents:\nOption 1: Zelle - varanasir@gmail.com / Ravi Varanasi\nOption 2: Bank transfer:\nName: Ravi Varanasi\nBank: Bank of America\nAccount#: 00333 18122\nRouting#: 121000358\nA/C Type: Checking\nFor other NRIs, please email: varanasir@gmail.com or call +91-9440366904",
    },
    {
      question: "Is my contribution tax deductible?",
      answer:
        "Yes for Indian taxpayers only - your payments to the trust are tax deductible under section 80 (C).",
    },
  ];

  return (
    <section id="faq" className="relative">
      {/* Background Images */}
      <div className="absolute top-0 right-0 z-10 opacity-50">
        <img src="/assets/png/left.png" alt="kolam" className="w-full" />
      </div>
      <div className="absolute bottom-0 left-0 z-10 opacity-50">
        <img src="/assets/png/right.png" alt="kolam" className="w-full" />
      </div>

      {/* FAQ Container */}
      <div className="bg-[#ECE5DF] flex flex-col items-center justify-center relative py-[3rem]">
        <div className="bg-white shadow-md rounded-lg p-6 w-[80%] md:w-[70%] lg:w-[60%] z-20">
          <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
            Frequently Asked Questions (FAQ)
          </h2>
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="border-b border-gray-300 pb-2">
                <button
                  onClick={() => toggleAccordion(index)}
                  className="w-full flex justify-between py-3 text-lg font-semibold text-[#8D2732]"
                >
                  {faq.question}
                  <span>{openIndex === index ? "-" : "+"}</span>
                </button>
                {openIndex === index && (
                  <p className="text-gray-600 mt-2 whitespace-pre-line">
                    {faq.answer}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
